import React, { Component, Fragment } from "react";
import { Redirect, Link } from "react-router-dom";
import {
  Layout,
  Icon,
  Tooltip,
  Row,
  Col,
  Button,
  Divider,
  Input,
  Avatar,
  Badge,
  message,
  Popover,
} from "antd";
import { ArrowLeftOutline } from "@ant-design/icons";
import "./layout.css";
import DashMenu from "./Menu";
import { Provider, Translate, Translator } from "react-translated";
import translation from "./lang/translation";
import Notificationbell, {
  NotificationBell,
} from "./components/notificationbell";
import F from "./Functions";
import {
  AGENCY_MANAGER,
  AGENCYMANAGER,
  CARD_HISTORY_TYPE,
  COPY_RAC_POP_OVER,
  debounceQuery,
  EA,
  EXTERNAL_RAC_COMPLETED_BY_CLIENT,
  FOLLOWUP,
  getNameInitials,
  LAUNCH_CALCULATOR_POP_OVER,
  LSP,
  PROSPECT,
  REQUEST_CALL_POP_OVER,
  REVIEWSCHEDULER,
  SUPER_ADMIN,
  SUPERADMIN,
  SWITCH_BACK_TO_ADMIN,
  SWITCH_BACK_TO_ADMIN_POP_OVER,
  VONBOARDER,
} from "./utils/Constants";
import SentFollowupModal from "./scenes/LandingPage/parts/sent-followup-modal";
import axios from "./api";
import { useBoundStore } from "./store/useBoundStore";
import { clearSharedDashboardDateState } from "./utils/clearSharedDashboardDateState";
import Cookies from "js-cookie";
import { useSocketStore } from "./store/slices/NotificationSlice/notification_slice";
import {
  GET_EXTERNAL_RAC_RECENT_FILES_COUNT,
  POST_ACKNOWLEDGE_EXT_RAC_FILE,
  REQUEST_CALL,
} from "./utils/Api_enums";

const { Header, Sider, Content, Footer } = Layout;

window.translate_db = translation;
window.translate_lang = "en";

class DashLayout extends Component {
  state = {
    unseen_notifications: 0,
    is_notification_cross_icon_clicked: false,
    external_rac_files_unseen: 0,
    new_external_rac_count: 0,
    ack_ids: [],
    logout: false,
    visibleNotification: false,
    dp_url: this.props.auth.user.dp_url || "",
    total_agencies: 0,
    collapsed: true,
    search: "",
    showSearch: false,
    toggle: false,
    selected_key: null,
    selected_menu: null,
    user: this.props.auth.user,
    send_followup_modal: false,
    isRequestButtonDisable: { vonboard: 0, review: 0, customerPath: 0 },
    isWizardValueUpdated: false,
    liveSupportSelected: false,
    sa_user_route: localStorage.getItem('sa_user_route'),
    menus: {
      agency_manager: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        {
          key: "agency_manager_profile",
          title: "Profile",
          path: "/profile/agency_manager",
          icon: "user",
          // iconKey: "agency_manager"profile
          iconKey: "profile",
        },
        {
          key: "training",
          title: "Training Library",
          path: "/training/details",
          icon: "video-camera",
          iconKey: "updated_training_library",
          // menu: [
          //   {
          //     key: "training1",
          //     title: "Hoopinsure U",
          //     path: "/training/hoopinsure-u",
          //   },
          //   {
          //     key: "training2",
          //     title: "Philosophy",
          //     path: "/training/philosophy",
          //   },
          //   {
          //     key: "training3",
          //     title: "System Training",
          //     path: "/training",
          //   },
          //   // {
          //   //     key: 'training3',
          //   //     title: 'Nuts & Bolts',
          //   //     path: '/training'
          //   // },
          //   // {
          //   //     key: 'training4',
          //   //     title: 'Customer Training',
          //   //     path: '/training'
          //   // },
          //   // {
          //   //     key: 'training5',
          //   //     title: '3rd Party Products',
          //   //     path: '/training'
          //   // }
          // ],
        },
      ],
      ea: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        {
          key: "bfiles",
          title: "B Files",
          icon: "folder",
          iconKey: "b_files",
          menu: [
            {
              key: "all-bfiles",
              title: "All B Files",
              path: "/bfiles",
            },
            // {
            //   key: "create-bfile",
            //   title: "Create A New B File",
            //   path: "/wizard?new",
            // },
            // {
            //   key: "no-sale-archive",
            //   title: "No Sale Archive",
            //   path: "/bfiles/no-sale-archive",
            // },
            // {
            //   key: "archived",
            //   title: "Archived",
            //   path: "/bfiles/archived",
            // },
            {
              key: "deleted-bfiles",
              title: "Deleted B Files",
              path: "/bfiles/deleted",
            },
            {
              key: "search-duplicate-customers",
              title: "Merge B Files",
              path: "/search-duplicate-customers",
              icon: "user",
              iconKey: "manage_customers",
            },
            // {
            //   key: "calendar-invites",
            //   title: "Calendar Invites",
            //   path: "/calendar-invites",
            // },
            // {
            //   key: "upload-customers",
            //   title: "Upload Customers",
            //   path: "",
            //   onClick: "showUploadCustomerModal",
            // },
            // {
            //   key: "upload-customers",
            //   title: "Upload Customers",
            //   path: "",
            //   onClick: "showUploadCustomerModal",
            // },
          ],
        },
        {
          key: "manage-users",
          title: "Manage Users",
          icon: "usergroup-add",
          iconKey: "updated_manage_users",

          menu: [
            {
              key: "manage-users-index",
              title: "Manage Users",
              path: "/manage-users",
            },
            {
              key: "invite-lsp",
              // title: "Invite Agency Sales Staff (Agency Staff)",
              title: "Invite Agency Staff",
              path: "/manage-users/invite-lsp",
            },
            // {
            //   key: "invite-mortgage-broker",
            //   title: "Mortgage Brokers",
            //   path: "/manage-users/invite-mortgage-broker",
            // },
            {
              key: "invited-users",
              title: "Invited Users",
              path: "/manage-users/invited-users",
            },
            {
              key: "inactive-users",
              title: "Inactive Users",
              path: "/manage-users/inactive-users",
            },
          ],
        },
        // New add  "Search Duplicate Customers"
        // {
        //   key: "search-duplicate-customers",
        //   title: "Manage Customers",
        //   path: "/search-duplicate-customers",
        //   icon: "user",
        //   iconKey: "manage_customers"
        // },
        {
          key: "profile",
          title: "Profile",
          path: "/profile",
          icon: "profile",
          iconKey: "profile",
        },
        {
          key: "notifications",
          title: "Notifications",
          path: "/ea-notification",
          icon: "bell",
          iconKey: "notification_bell",
        },
        {
          key: "training",
          title: "Training Library",
          path: "/training/details",
          icon: "video-camera",
          iconKey: "updated_training_library",
          // menu: [
          //   {
          //     key: "training1",
          //     title: "Hoopinsure U",
          //     path: "/training/hoopinsure-u",
          //   },
          //   {
          //     key: "training2",
          //     title: "Philosophy",
          //     path: "/training/philosophy",
          //   },
          //   {
          //     key: "training3",
          //     title: "System Training",
          //     path: "/training",
          //   },
          //   // {
          //   //     key: 'training3',
          //   //     title: 'Nuts & Bolts',
          //   //     path: '/training'
          //   // },
          //   // {
          //   //     key: 'training4',
          //   //     title: 'Customer Training',
          //   //     path: '/training'
          //   // },
          //   // {
          //   //     key: 'training5',
          //   //     title: '3rd Party Products',
          //   //     path: '/training'
          //   // }
          // ],
        },
        // {
        //   key: "notifications",
        //   title: "Notifications",
        //   path: "/ea-notification",
        //   icon: "bell",
        // },
        {
          key: "reward-program",
          title: "Reward Program",
          icon: "gift",
          iconKey: "reward_points",
          menu: [
            {
              key: "reward-program-index",
              title: "Reward Program",
              path: "/reward-program",
            },
            {
              key: "order-history",
              title: "Order History",
              path: "/reward-program/order-history",
            },
            {
              key: "send-a-gift",
              title: "Send a Gift",
              path: "/reward-program/send-a-gift",
            },
          ],
        },
        // {
        //   key: "external-bFile-Link",
        //   title: "External B File Link",
        //   path: "/template/external-b-file-link",
        //   icon: "export",
        //   // iconKey: "external_b_file_link"
        // },
        {
          key: "email-template",
          title: "Email Template",
          path: "/template/email-template",
          icon: "mail",
          iconKey: "email_template"
        },
        // {
        //   key: "send-a-gift",
        //   title: "Send a Gift",
        //   path: "/send-a-gift",
        //   icon: "gift",
        // },
        // {
        //   key: "reporting",
        //   title: "Reporting",
        //   path: "/reporting",
        //   icon: "area-chart",
        // },
        // {
        //   key: "gamification",
        //   title: "Gamification",
        //   icon: "trophy",
        //   menu: [
        //     {
        //       key: "gamification-index",
        //       title: "Gamification",
        //       path: "/gamification",
        //     },
        //     {
        //       key: "winners",
        //       title: "Winners",
        //       path: "/gamification/winners",
        //     },
        //     {
        //       key: "archive",
        //       title: "Archive",
        //       path: "/gamification/archive",
        //     },
        //   ],
        // },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        {
          key: "help",
          title: "Live Support",
          path: "",
          icon: "question-circle",
          iconKey: "question-circle",
          onClick: "openChat",
          // onClick: () => {
          //   //this.setState({ help_modal: true })
          //   window.openChat();
          // },
        },

      ],
      lsp: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // {
        //     key: 'manage-users',
        //     title: 'Training',
        //     icon: 'usergroup-add',
        //     menu: [
        //         {
        //             key: 'videos',
        //             title: 'Training',
        //             path: '/video'
        //         },
        //         {
        //             key: 'training',
        //             title: 'Uploaded training',
        //             path: '/training-copy'
        //         },
        //         {
        //             key: 'invite-admin',
        //             title: 'Notification',
        //             path: '/notification-admin'
        //         }
        //     ]
        // },
        {
          key: "bfiles",
          title: "B Files",
          icon: "folder",
          iconKey: "b_files",
          menu: [
            {
              key: "all-bfiles",
              title: "All B Files",
              path: "/bfiles",
            },
            // {
            //   key: "create-bfile",
            //   title: "Create A New B File",
            //   path: "/wizard",
            // },
            // {
            //   key: "no-sale-archive",
            //   title: "No Sale Archive",
            //   path: "/bfiles/no-sale-archive",
            // },
            // {
            //   key: "archived",
            //   title: "Archived",
            //   path: "/bfiles/archived",
            // },
            {
              key: "deleted-bfiles",
              title: "Deleted B Files",
              path: "/bfiles/deleted",
            },
            {
              key: "search-duplicate-customers",
              title: "Merge B Files",
              path: "/search-duplicate-customers",
              icon: "user",
              iconKey: "manage_customers",
            },
            // {
            //   key: "calendar-invites",
            //   title: "Calendar Invites",
            //   path: "/calendar-invites",
            // },
            // {  Removed from Sidebar left menu asper requirement
            //   key: "new-quote",
            //   title: "New Quote",
            //   path: "/wizard/new-quote",
            // },
            // {  Removed from Sidebar left menu asper requirement
            //   key: "upload-customers",
            //   title: "Upload Customers",
            //   path: "",
            //   onClick: "showUploadCustomerModal"
            // {  Removed from Sidebar left menu asper requirement
            //   key: "new-quote",
            //   title: "New Quote",
            //   path: "/wizard/new-quote",
            // },
            // {  Removed from Sidebar left menu asper requirement
            //   key: "upload-customers",
            //   title: "Upload Customers",
            //   path: "",
            //   onClick: "showUploadCustomerModal"

            // },
            // },
          ],
        },
        // {
        //   key: "search-duplicate-customers",
        //   title: "Manage Customers",
        //   path: "/search-duplicate-customers",
        //   icon: "user",
        //   iconKey: "manage_customers",
        // },
        // {
        //   key: "search-duplicate-customers",
        //   title: "Merge Files",
        //   path: "/search-duplicate-customers",
        //   icon: "user",
        //   active: true
        // },
        {
          key: "profile",
          title: "Profile",
          path: "/profile",
          icon: "user",
          iconKey: "profile",
        },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        {
          key: "training",
          title: "Training Library",
          path: "/training/details",
          icon: "video-camera",
          iconKey: "updated_training_library",
          // menu: [
          //   {
          //     key: "training1",
          //     title: "Hoopinsure U",
          //     path: "/training/hoopinsure-u",
          //   },
          //   {
          //     key: "training2",
          //     title: "Philosophy",
          //     path: "/training/philosophy",
          //   },
          //   {
          //     key: "training3",
          //     title: "System Training",
          //     path: "/training",
          //   },
          // ],
        },
        {
          key: "help",
          title: "Live Support",
          path: "",
          icon: "question-circle",
          iconKey: "question-circle",
          onClick: "openChat",
        },
        // {
        //   key: "external-bFile-Link",
        //   title: "External B File Link",
        //   path: "/template/external-b-file-link",
        //   icon: "export",
        //   // iconKey: "external_b_file_link"

        // },
        {
          key: "email-template",
          title: "Email Template",
          path: "/template/email-template",
          icon: "mail",
          iconKey: "email_template"
        },
      ],
      efs: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        {
          key: "bfiles",
          title: "B Files",
          icon: "folder",
          iconKey: "b_files",
          menu: [
            {
              key: "all-bfiles",
              title: "All B Files",
              path: "/bfiles",
            },
          ],
        },
        {
          key: "training",
          title: "Training Library",
          path: "/training/details",
          icon: "video-camera",
          iconKey: "updated_training_library",
          // menu: [
          //   {
          //     key: "training1",
          //     title: "Hoopinsure U",
          //     path: "/training/hoopinsure-u",
          //   },

          //   {
          //     key: "training2",
          //     title: "Philosophy",
          //     path: "/training/philosophy",
          //   },
          //   {
          //     key: "training3",
          //     title: "System Training",
          //     path: "/training",
          //   },
          // ],
        },
        {
          key: "profile",
          title: "Profile",
          path: "/profile",
          icon: "user",
          iconKey: "profile",
        },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      vonboarder: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // {
        //   key: "dedicated-agency-dashboard",
        //   title: "Dedicated Agency Dashboard",
        //   path: "/dashboard/select-agency",
        //   icon: "appstore",
        //   iconKey: "dedicated_agency",
        // },
        // {
        //   key: "training",
        //   title: "Training Library",
        //   path: "/training/details",
        //   icon: "video-camera",
        //   // menu: [
        //   //   {
        //   //     key: "training1",
        //   //     title: "Hoopinsure U",
        //   //     path: "/training/hoopinsure-u",
        //   //   },
        //   //   {
        //   //     key: "training2",
        //   //     title: "Philosophy",
        //   //     path: "/training/philosophy",
        //   //   },
        //   //   {
        //   //     key: "training3",
        //   //     title: "System Training",
        //   //     path: "/training",
        //   //   },
        //   //   // {
        //   //   //     key: 'training3',
        //   //   //     title: 'Nuts & Bolts',
        //   //   //     path: '/training'
        //   //   // },
        //   //   // {
        //   //   //     key: 'training4',
        //   //   //     title: 'Customer Training',
        //   //   //     path: '/training'
        //   //   // },
        //   //   // {
        //   //   //     key: 'training5',
        //   //   //     title: '3rd Party Products',
        //   //   //     path: '/training'
        //   //   // }
        //   // ],
        // },
        // {
        //   key: "all-bfiles",
        //   title: "All B Files",
        //   // path: "/bfiles",
        //   path: "/bfiles",
        //   iconKey: "b_files",
        // },
        // {
        //   key: "claimed-bfiles",
        //   title: "My Claimed B Files",
        //   path: "/newbfiles/claimed",
        //   iconKey: "b_files",
        // },
        // {
        //   key: "bfiles",
        //   title: "All B-Files",
        //   icon: "folder",
        //   iconKey:"b_files",
        //   menu: [
        //     // add this FS routes
        //     {
        //       key: "all-bfiles",
        //       title: "All B-Files",
        //       // path: "/bfiles",
        //       path: "/bfilesNew",
        //     },
        //     // commented as nausheen sugessted no noeed now
        //     // {
        //     //   key: "claimed-bfiles",
        //     //   title: "My Claimed B-Files",
        //     //   path: "/bfiles/claimed",
        //     // },
        //     // Hide below
        //     // {
        //     //   key: "all-virtual-bfiles",
        //     //   title: "All Virtual B-Files",
        //     //   path: "/bfiles",
        //     // },
        //     // {
        //     //   key: "no-sale-archive",
        //     //   title: "No Sale Archive",
        //     //   path: "/bfiles/no-sale-archive",
        //     // },
        //     // {
        //     //   key: "archived",
        //     //   title: "Archived",
        //     //   path: "/bfiles/archived",
        //     // },
        //     // {
        //     //   key: "calendar-invites",
        //     //   title: "Calendar Invites",
        //     //   path: "/calendar-invites",
        //     // },
        //     // {
        //     //   key: "upload-customers",
        //     //   title: "Setup Appointment",
        //     //   path: "",
        //     // },
        //     // {
        //     //   key: "upload-customers",
        //     //   title: "Upload Customers",
        //     //   path: "",
        //     //   onClick: () => {
        //     //     this.showVonUploadCustomerModal();
        //     //   },
        //     // },
        //   ],
        // },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      vonboardadmin: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // All B files are commented for FS Admin
        // {
        //   key: "bfiles",
        //   title: "B Files",
        //   icon: "folder",
        //   iconKey: "b_files",
        //   menu: [
        //     {
        //       key: "all-bfiles",
        //       title: "All B Files",
        //       path: "/bfiles",
        //     },
        //     {
        //       key: "no-sale-archive",
        //       title: "No Sale Archive",
        //       path: "/bfiles/no-sale-archive",
        //     },
        //     {
        //       key: "archived",
        //       title: "Archived",
        //       path: "/bfiles/archived",
        //     },
        //     {
        //       key: "calendar-invites",
        //       title: "Calendar Invites",
        //       path: "/calendar-invites",
        //     },
        //   ],
        // },
        {
          key: "manage-schedulers",
          title: "Manage Schedulers",
          icon: "user",
          iconKey: "manage_schedulers",
          menu: [
            {
              key: "invite-vonborder-new",
              title: "Invite Schedulers",
              path: "/manage-users/invite-vo-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              // key: "manage-users-rs",
              key: "manage-scheduler-rs",
              title: "Manage Schedulers",
              path: "/manage-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            // {
            //   key: "invite-rs",
            //   title: "Invite a Review Scheduler",
            //   path: "/manage-users/invite-rs",
            //   user_type: 'REVIEWADMIN'
            // },
            {
              // key: "invited-users-rs",
              key: "invited-review-scheduler-rs",
              title: "Invited Schedulers",
              path: "/manage-users/invited-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              key: "inactive-schedulers-rs",
              title: "Inactive Schedulers",
              path: "/manage-users/inactive-users-new",
              user_type: "BOBREVIEWADMIN",
            },

            // {
            //   key: "active-new-rs",
            //   title: "Activated Schedulers",
            //   path: "/review-schedulers/active-new",
            //   user_type: 'BOBREVIEWADMIN'
            // },
            // not showing edit upload to review admin only show to super admin
            // {
            //   key: "edit-upload",
            //   title: "Edit Uploads",
            //   path: "/super-admin/edit-upload",
            //   icon: "user",
            // },
            // {
            //   key: "bfiles-vonborder",
            //   title: "B Files",
            //   icon: "folder",
            //   iconKey: "b_files",
            //   menu: [
            //     {
            //       key: "all-bfiles-vonborder",
            //       title: "All B Files",
            //       path: "/bfiles",
            //       user_type: 'BOBADMIN'
            //     },
            //     // {
            //     //   key: "no-sale-archive-vonborder",
            //     //   title: "No Sale Archive",
            //     //   path: "/bfiles/no-sale-archive",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //     // {
            //     //   key: "archived-vonborder",
            //     //   title: "Archived",
            //     //   path: "/bfiles/archived",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //   ],
            // },
          ],
        },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      reviewscheduler: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // {
        //   key: "dedicated-agency-dashboard",
        //   title: "Dedicated Agency Dashboard",
        //   path: "/dashboard/select-agency",
        //   icon: "appstore",
        //   iconKey: "dedicated_agency",
        // },
        // {
        //   key: "bfiles",
        //   title: "All B Files",
        //   icon: "folder",
        //   iconKey: "b_files",
        //   path: "/bfiles",
        //   // menu: [
        //   //   {
        //   //     key: "all-bfiles",
        //   //     title: "All B Files",
        //   //     path: "/bfiles",
        //   //   },
        //   //   {
        //   //     key: "upcoming-calls",
        //   //     title: "Upcoming Calls",
        //   //     path: "/bfiles/rs-upcoming-calls",
        //   //   },
        //   //   // {
        //   //   //   key: "upload-customers",
        //   //   //   title: "Upload Customers",
        //   //   //   path: "",
        //   //   //   onClick: () => {
        //   //   //     this.showReviewSchedulerUploadCustomerModal();
        //   //   //   },
        //   //   // },
        //   // ],
        // },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      rso: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
        },
        {
          key: "dedicated-agency-dashboard",
          title: "Dedicated Agency Dashboard",
          path: "/dashboard/select-agency",
          icon: "appstore",
          iconKey: "dedicated_agency",
        },
        {
          key: "bfiles",
          title: "B Files",
          icon: "folder",
          iconKey: "b_files",
          menu: [
            {
              key: "claimed-bfiles",
              title: "My Claimed B Files",
              path: "/bfiles/claimed",
            },
            {
              key: "all-bfiles",
              title: "All B Files",
              path: "/bfiles",
            },
            {
              key: "upcoming-calls",
              title: "Upcoming Calls",
              path: "/bfiles/rs-upcoming-calls",
            },
            {
              key: "no-sale-archive",
              title: "No Sale Archive",
              path: "/bfiles/no-sale-archive",
            },
            // {
            //   key: "archived",
            //   title: "Archived",
            //   path: "/bfiles/archived",
            // },
            {
              key: "calendar-invites",
              title: "Calendar Invites",
              path: "/calendar-invites",
            },
            {
              key: "upload-customers",
              title: "Upload Customers",
              path: "",
              onClick: "showReviewSchedulerUploadCustomerModal",
            },
          ],
        },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      reviewadmin: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // commented as nausheensuggest no need now
        // {
        //   key: "scheduled-calls",
        //   title: "Scheduled Calls",
        //   path: "/bfiles/scheduled-calls",
        //   icon: "calendar",
        // },
        // {
        //   key: "calendar-invites",
        //   title: "Calendar Invites",
        //   path: "/calendar-invites",
        //   icon: "calendar",
        // },
        {
          key: "manage-schedulers",
          title: "Manage Schedulers",
          icon: "user",
          iconKey: "manage_schedulers",
          menu: [
            {
              key: "invite-vonborder-new",
              title: "Invite Schedulers",
              path: "/manage-users/invite-vo-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              // key: "manage-users-rs",
              key: "manage-scheduler-rs",
              title: "Manage Schedulers",
              path: "/manage-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            // {
            //   key: "invite-rs",
            //   title: "Invite a Review Scheduler",
            //   path: "/manage-users/invite-rs",
            //   user_type: 'REVIEWADMIN'
            // },
            {
              // key: "invited-users-rs",
              key: "invited-review-scheduler-rs",
              title: "Invited Schedulers",
              path: "/manage-users/invited-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              key: "inactive-schedulers-rs",
              title: "Inactive Schedulers",
              path: "/manage-users/inactive-users-new",
              user_type: "BOBREVIEWADMIN",
            },

            // {
            //   key: "active-new-rs",
            //   title: "Activated Schedulers",
            //   path: "/review-schedulers/active-new",
            //   user_type: 'BOBREVIEWADMIN'
            // },
            // not showing edit upload to review admin only show to super admin
            // {
            //   key: "edit-upload",
            //   title: "Edit Uploads",
            //   path: "/super-admin/edit-upload",
            //   icon: "user",
            // },
            // {
            //   key: "bfiles-vonborder",
            //   title: "B Files",
            //   icon: "folder",
            //   iconKey: "b_files",
            //   menu: [
            //     {
            //       key: "all-bfiles-vonborder",
            //       title: "All B Files",
            //       path: "/bfiles",
            //       user_type: 'BOBADMIN'
            //     },
            //     // {
            //     //   key: "no-sale-archive-vonborder",
            //     //   title: "No Sale Archive",
            //     //   path: "/bfiles/no-sale-archive",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //     // {
            //     //   key: "archived-vonborder",
            //     //   title: "Archived",
            //     //   path: "/bfiles/archived",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //   ],
            // },
          ],
        },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/features',
        //     icon: 'tool'
        // },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      superadmin: [
        {
          key: "upload-customers",
          title: "Upload Customers",
          path: "",
          icon: "user",
          onClick: "showAdminUploadCustomerModal",
          iconKey: "upload_customers",
        },
        {
          key: "active-agencies",
          title: "Active Agencies",
          path: "/super-admin/active-agencies",
          icon: "team",
          iconKey: "active_agencies",
        },
        {
          key: "inactive-agencies",
          title: "Inactive Agencies",
          path: "/super-admin/inactive-agencies",
          icon: "close-square-o",
          iconKey: "Inactive_agencies", // no icon key take its need group icon
        },
        {
          key: "search-staff",
          title: "Search Staff",
          path: "/super-admin/search-staff",
          icon: "team",
          iconKey: "search_staff",
        },
        {
          key: "training",
          title: "Training Library Upload",
          path: "/training/video",
          icon: "video-camera",
          iconKey: "training_library_upload",
          // menu: [
          //   {
          //     key: "videos",
          //     title: "Upload Training Video",
          //     path: "/training/video",
          //   },
          //   {
          //     key: "training1",
          //     title: "Hoopinsure U",
          //     path: "/training/hoopinsure-u",
          //   },
          //   {
          //     key: "training2",
          //     title: "Philosophy",
          //     path: "/training/philosophy",
          //   },
          //   {
          //     key: "training3",
          //     title: "System Training",
          //     path: "/training",
          //   },
          // ],
        },
        /*{
                  key: 'in-10-30-stats',
                  title: '10 in 30 stats',
                  path: '/super-admin/10-in-30-stats',
                  icon: 'gift'
              },*/

        {
          key: "training-video-list",
          title: "Training Library",
          path: "/training/details",
          icon: "video-camera",
          iconKey: "updated_training_library",
        },
        {
          key: "locked-users",
          title: "Locked Users",
          path: "/manage-users/locked-users",
          user_type: "SUPER_ADMIN",
          icon: "lock",
          iconKey: "locked_users",
        },
        // {
        //   key: "stats",
        //   title: "Stats",
        //   path: "/super-admin/stats",
        //   icon: "area-chart",
        // },
        // {
        //   key: "invite-admin",
        //   title: "Notification",
        //   path: "/notification-admin",
        //   icon: "bell",
        // },
        // {
        //   key: "agency-stats",
        //   title: "Stats by Agency (CSV)",
        //   path: "/super-admin/agency-stats",
        //   icon: "area-chart",
        // },
        {
          key: "last-login",
          title: "Last Login",
          path: "/super-admin/last-login",
          icon: "area-chart",
          iconKey: "last_login",
        },
        // {
        //   key: "onboard-agencies",
        //   title: "Onboard Agencies",
        //   path: "/super-admin/onboard-agencies",
        //   icon: "area-chart",
        // },
        // {
        //   key: "onboard-sent-bfiles",
        //   title: "Onboard Sent B Files",
        //   path: "/super-admin/onboard-sent-bfiles",
        //   icon: "area-chart",
        // },
        {
          key: "global-dashboard",
          title : "Global Dashboard",
          path: "/super-admin/global-dashboard",
          icon: "area-chart",
        },
        {
          key: "manage",
          // title: "Manage Users",
          title: "Manage Agency Manager",
          icon: "usergroup-add",
          iconKey: "updated_manage_users",
          menu: [
            {
              key: "agency-manager",
              title: "Agency Manager",
              path: "/super-admin/agency-manager",
              icon: "user",
              iconKey: "updated_manage_users",
            },
            {
              key: "manage-users-index",
              title: "Manage Users",
              path: "/manage-users",
              user_type: "SUPER_ADMIN",
            },
            {
              key: "invite-agency-manager",
              title: "Invite Agency Manager",
              path: "/manage-users/invite-agency-manager",
              user_type: "SUPER_ADMIN",
            },
            {
              key: "invited-users",
              title: "Invited Users",
              path: "/manage-users/invited-users",
              user_type: "SUPER_ADMIN",
            },
            {
              key: "inactive-users",
              title: "Inactive Users",
              path: "/manage-users/inactive-users",
              user_type: "SUPER_ADMIN",
            },
          ],
        },
        // {
        //   key: "review-schedulers",
        //   title: "Review Schedulers",
        //   path: "/super-admin/review-schedulers",
        //   icon: "user",
        // },

        // commented code of Review Schedulers Admin
        // {
        //   key: "review-schedulers-1",
        //   title: "Review Schedulers Admin",
        //   icon: "user",
        //   menu: [
        //     {
        //       key: "dashboard-rs-admin",
        //       title: "Dashboard",
        //       path: "/dashboard",
        //       icon: "dashboard",
        //       iconKey: "dashboard",
        //       user_type: 'REVIEWADMIN'
        //     },
        //     {
        //       key: "scheduled-calls-rs-admin",
        //       title: "Scheduled Calls",
        //       path: "/bfiles/scheduled-calls",
        //       icon: "calendar",
        //       user_type: 'REVIEWADMIN'
        //     },
        //     {
        //       key: "calendar-invites-rs-admin",
        //       title: "Calendar Invites",
        //       path: "/calendar-invites",
        //       icon: "calendar",
        //       user_type: 'REVIEWADMIN'
        //     },
        //     {
        //       key: "manage-rs",
        //       title: "Manage Users",
        //       icon: "usergroup-add",
        //       iconKey: "updated_manage_users",
        //       menu: [
        //         {
        //           key: "manage-users-rs",
        //           title: "Manage Users",
        //           path: "/manage-users",
        //           user_type: 'REVIEWADMIN'
        //         },
        //         {
        //           key: "invite-rs",
        //           title: "Invite a Review Scheduler",
        //           path: "/manage-users/invite-rs",
        //           user_type: 'REVIEWADMIN'
        //         },
        //         {
        //           key: "invited-users-rs",
        //           title: "Invited Users",
        //           path: "/manage-users/invited-users",
        //           user_type: "REVIEWADMIN"
        //         },
        //         {
        //           key: "inactive-users-rs",
        //           title: "Inactive Users",
        //           path: "/manage-users/inactive-users",
        //           user_type: 'REVIEWADMIN'
        //         },
        //       ],
        //     },
        //     {
        //       key: "active-rs",
        //       title: "Activated Users",
        //       path: "/review-schedulers/active",
        //       user_type: 'REVIEWADMIN'
        //     },
        //     {
        //       key: "deactive-rs",
        //       title: "Deactivated Users",
        //       path: "/review-schedulers/deactive",
        //       user_type: 'REVIEWADMIN'
        //     },
        //     {
        //       key: "rs-reporting",
        //       title: "RS Reporting",
        //       path: "/super-admin/rs-reporting",
        //       icon: "area-chart",
        //     },
        //     {
        //       key: "edit-upload",
        //       title: "Edit Uploads",
        //       path: "/super-admin/edit-upload",
        //       icon: "user",
        //     },
        //     // {
        //     //   key: "help-rs",
        //     //   title: "Live Support",
        //     //   path: "",
        //     //   icon: "question-circle-o",
        //     //   onClick: () => {
        //     //     //this.setState({ help_modal: true })
        //     //     window.openChat();
        //     //   },
        //     // },
        //   ],
        // },

        // new-layout menu of manage schedulers
        {
          key: "manage-schedulers",
          title: "Manage Schedulers",
          icon: "user",
          iconKey: "manage_schedulers",
          menu: [
            {
              key: "dashboard-rs-admin",
              title: "Dashboard",
              path: "/dashboard",
              icon: "dashboard",
              iconKey: "dashboard",
              user_type: "BOBREVIEWADMIN",
            },
            {
              key: "invite-vonborder-new",
              title: "Invite Schedulers",
              path: "/manage-users/invite-vo-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              // key: "manage-users-rs",
              key: "manage-scheduler-rs",
              title: "Manage Schedulers",
              path: "/manage-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            // {
            //   key: "invite-rs",
            //   title: "Invite a Review Scheduler",
            //   path: "/manage-users/invite-rs",
            //   user_type: 'REVIEWADMIN'
            // },
            {
              // key: "invited-users-rs",
              key: "invited-review-scheduler-rs",
              title: "Invited Schedulers",
              path: "/manage-users/invited-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              key: "inactive-schedulers-rs",
              title: "Inactive Schedulers",
              path: "/manage-users/inactive-users-new",
              user_type: "BOBREVIEWADMIN",
            },

            // {
            //   key: "active-new-rs",
            //   title: "Activated Schedulers",
            //   path: "/review-schedulers/active-new",
            //   user_type: 'BOBREVIEWADMIN'
            // },
            {
              key: "edit-upload",
              title: "Edit Uploads",
              path: "/super-admin/edit-upload",
              icon: "user",
            },
            // {
            //   key: "bfiles-vonborder",
            //   title: "B Files",
            //   icon: "folder",
            //   iconKey: "b_files",
            //   menu: [
            //     {
            //       key: "all-bfiles-vonborder",
            //       title: "All B Files",
            //       path: "/bfiles",
            //       user_type: 'BOBADMIN'
            //     },
            //     // {
            //     //   key: "no-sale-archive-vonborder",
            //     //   title: "No Sale Archive",
            //     //   path: "/bfiles/no-sale-archive",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //     // {
            //     //   key: "archived-vonborder",
            //     //   title: "Archived",
            //     //   path: "/bfiles/archived",
            //     //   user_type: 'BOBADMIN'
            //     // },
            //   ],
            // },
          ],
        },

        //  commented menu of Follow-Up  Specialist Admin
        // {
        //   key: "vonborderAdmin",
        //   title: "Follow-Up Specialist Admin", // rename from Virtual Onborder Admin to  follow up specialist admin
        //   icon: "user",
        //   menu: [

        //     // {
        //     //   key: "dashboard-vonborder-admin",
        //     //   title: "Dashboard",
        //     //   path: "/dashboard",
        //     //   icon: "dashboard",
        //     //   user_type:'BOBADMIN'
        //     // },
        //     {
        //       key: "bfiles-vonborder",
        //       title: "B Files",
        //       icon: "folder",
        //       iconKey: "b_files",
        //       menu: [
        //         {
        //           key: "all-bfiles-vonborder",
        //           title: "All B Files",
        //           path: "/bfiles",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "no-sale-archive-vonborder",
        //           title: "No Sale Archive",
        //           path: "/bfiles/no-sale-archive",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "archived-vonborder",
        //           title: "Archived",
        //           path: "/bfiles/archived",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "calendar-invites-vonborder",
        //           title: "Calendar Invites",
        //           path: "/calendar-invites",
        //           user_type: 'BOBADMIN'
        //         },
        //       ],
        //     },
        //     {
        //       key: "manage-vonborder",
        //       title: "Manage Users",
        //       icon: "usergroup-add",
        //       iconKey: "updated_manage_users",
        //       menu: [
        //         {
        //           key: "manage-users-vonborder",
        //           title: "Manage Users",
        //           path: "/manage-users",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "invite-vonborder",
        //           title: "Invite a Virtual Onboarder",
        //           path: "/manage-users/invite-vo",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "invited-users-vonborder",
        //           title: "Invited Users",
        //           path: "/manage-users/invited-users",
        //           user_type: 'BOBADMIN'
        //         },
        //         {
        //           key: "inactive-users-vonborder",
        //           title: "Inactive Users",
        //           path: "/manage-users/inactive-users",
        //           user_type: 'BOBADMIN'
        //         },
        //       ],
        //     },

        //     // {
        //     //   key: "help-vo",
        //     //   title: "Live Support",
        //     //   path: "",
        //     //   icon: "question-circle-o",
        //     //   onClick: () => {
        //     //     //this.setState({ help_modal: true })
        //     //     window.openChat();
        //     //   },
        //     // },
        //   ]
        // },

        // {
        //   key: "virtual-follow-ups",
        //   title: "Virtual Follow-Ups",
        //   path: "/super-admin/virtual-follow-ups",
        //   icon: "user"
        // },
        // {
        //   key: "agency-manager",
        //   title: "Agency Manager",
        //   path: "/super-admin/agency-manager",
        //   icon: "user",
        //   iconKey: "updated_manage_users",
        // },
        // {
        //   key: "region-stats",
        //   title: "Region Stats",
        //   path: "/super-admin/region-stats",
        //   icon: "area-chart",
        // },
        {
          key: "tango-accounts",
          title: "Tango Accounts",
          path: "/super-admin/tango-accounts",
          icon: "star-o",
          iconKey: "tango_account",
        },
        // {
        //   key: "email-content",
        //   title: "Email Content",
        //   path: "/super-admin/email-content",
        //   icon: "mail",
        // },
        // {
        //     key: 'features',
        //     title: 'Features & Fixes',
        //     path: '/super-admin/features',
        //     icon: 'tool'
        // },
        {
          key: "profile",
          title: "Profile",
          path: "/profile",
          icon: "user",
          iconKey: "profile",
        },
        {
          key: "email-template",
          title: "Email Template",
          path: "/template/email-template",
          icon: "mail",
          iconKey: "email_template"
        },

        // {
        //   key: "upload-dnc",
        //   title: "Upload DNC",
        //   path: "",
        //   icon: "user",
        //   onClick: "showDncCustomerModal"
        // },
        // {
        //   key: "dnc-customers",
        //   title: "DNC Users",
        //   path: "/dnc-customers",
        //   icon: "team",
        // },
      ],
      mortgage_broker: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        {
          key: "leads",
          title: "Leads",
          path: "/bfiles/mb-leads",
          icon: "folder",
        },
        {
          key: "new-lead",
          title: "New Lead",
          path: "/new-lead",
          icon: "plus",
        },
        // {
        //   key: "help",
        //   title: "Live Support",
        //   path: "",
        //   icon: "question-circle-o",
        //   onClick: "openChat"
        // },
      ],
      // new sidebar menu RSFS ADMIN
      RSFS_Admin: [
        {
          key: "dashboard-rs-admin",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
          user_type: "BOBREVIEWADMIN",
        },
        {
          key: "RSFS_Admin",
          title: "Manage Schedulers",
          icon: "user",
          menu: [
            {
              key: "invite-vonborder-new",
              title: "Invite Schedulers",
              path: "/manage-users/invite-vo-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              // key: "manage-users-rs",
              key: "manage-scheduler-rs",
              title: "Manage Schedulers",
              path: "/manage-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            // {
            //   key: "invite-rs",
            //   title: "Invite a Review Scheduler",
            //   path: "/manage-users/invite-rs",
            //   user_type: 'REVIEWADMIN'
            // },
            {
              // key: "invited-users-rs",
              key: "invited-review-scheduler-rs",
              title: "Invited Schedulers",
              path: "/manage-users/invited-users-new",
              user_type: "BOBREVIEWADMIN",
            },
            {
              key: "inactive-schedulers-rs",
              title: "Inactive Schedulers",
              path: "/manage-users/inactive-users-new",
              user_type: "BOBREVIEWADMIN",
            },

            {
              key: "active-new-rs",
              title: "Activated Schedulers",
              path: "/review-schedulers/active-new",
              user_type: "BOBREVIEWADMIN",
            },
            // not showing edit upload to review admin only show to super admin
            // {
            //   key: "edit-upload",
            //   title: "Edit Uploads",
            //   path: "/super-admin/edit-upload",
            //   icon: "user",
            // },

            // bobrsadmin  bob review admin  removed
            // {
            //   key: "bfiles-vonborder",
            //   title: "B Files",
            //   icon: "folder",
            //   iconKey:"b_files",
            //   menu: [
            //     {
            //       key: "all-bfiles-vonborder",
            //       title: "All B Files",
            //       path: "/bfiles",
            //       user_type: 'BOBREVIEWADMIN'
            //     },
            //     {
            //       key: "no-sale-archive-vonborder",
            //       title: "No Sale Archive",
            //       path: "/bfiles/no-sale-archive",
            //       user_type: 'BOBREVIEWADMIN'
            //     },
            //     {
            //       key: "archived-vonborder",
            //       title: "Archived",
            //       path: "/bfiles/archived",
            //       user_type: 'BOBREVIEWADMIN'
            //     },
            //   ],
            // },
          ],
        },
      ],
      // VONSCHEDULER sidebar menu
      VONSCHEDULER: [
        {
          key: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
          icon: "dashboard",
          iconKey: "dashboard",
        },
        // {
        //   key: "dedicated-agency-dashboard",
        //   title: "Dedicated Agency Dashboard",
        //   path: "/dashboard/select-agency",
        //   icon: "appstore",
        //   iconKey: "dedicated_agency",
        // },
        // {
        //   key: "all-bfiles",
        //   title: "All B Files",
        //   path: "/bfiles",
        //   iconKey: "b_files",
        // },
        // {
        //   key: "claimed-bfiles",
        //   title: "My Claimed B-Files",
        //   path: "/newbfiles/claimed",
        //   iconKey: "b_files",
        // },
      ],
    },
  };

  loadUser() {
    axios.get("/api/user").then((res) => {
      if (!this.isLayoutMounted) return;
      let loginUser = res.data;
      useBoundStore.getState().setUserInfo(loginUser);
      this.setState({
        dp_url: res.data.dp_url,
      });

      if (
        res &&
        res.data &&
        res.data.user_agency_assoc[0] &&
        res.data.user_agency_assoc[0].agency_id
      ) {
        axios
          .get(`/api/agencies/${res.data.user_agency_assoc[0].agency_id}`)
          .then((e) => {
            if (!this.isLayoutMounted) return;
            const userInfo = Cookies.get("user_info");
            if (userInfo) {
              const userObj = JSON.parse(userInfo);
              userObj.agency_id =
                res.data &&
                res.data.user_agency_assoc &&
                res.data.user_agency_assoc[0] &&
                res.data.user_agency_assoc[0].agency_id;
              Cookies.set("user_info", JSON.stringify(userObj),
                {
                  secure: true,           //  HTTPS only
                  sameSite: 'Lax',        // Add this — fixes the scan finding
                  path: '/',              // explicit path
                }
              );
            }
            if (e && e.data) {
              const customerPath = this.props.location.pathname.includes(
                "customer",
              )
                ? 0
                : 1;
              useBoundStore.getState().setAgencyInfo(e.data);
              this.setState((prevState) => ({
                isRequestButtonDisable: {
                  ...prevState.isRequestButtonDisable,
                  vonboard: e.data.vonboard,
                  review: e.data.review,
                  is_lead: e.data.is_lead,
                  is_opportunity: e.data.is_opportunity,
                  show_lead_card_appointment_details:
                    e.data.show_lead_card_appointment_details,
                  customerPath: customerPath,
                },
              }));
            }
          });
      }
    });
  }

  fetchRecentExtRACCount = async () => {
    const primary_ea_id =
      useBoundStore.getState().AgencyInfo.primary_ea_id;

    try {
      const res = await axios.get(
        GET_EXTERNAL_RAC_RECENT_FILES_COUNT(primary_ea_id)
      );

      let ack_id = [];
      let unseenCount = 0;

      if (res && res.data) {
        unseenCount = res.data.ext_rac_files_unseen || 0;

        if (Array.isArray(res.data.data) && res.data.data.length > 0) {
          ack_id = res.data.data.map((e) => e.id);
        }
        useBoundStore.getState().setNotificationSeenUnseen({
          external_rac_files_unseen: unseenCount,
        });
      }

      this.setState({
        new_external_rac_count: unseenCount,
        ack_ids: ack_id,
      });
    } catch (err) {
      console.error("Error fetching count:", err);
    }
  };


  handleClickAcknowledgeRACFiles = async () => {
    let userId =
      this.props.auth.user.user_type === EA
        ? this.props.auth.user.id
        : this.state.parent_id;
    try {
      // 1️⃣ Acknowledge the external Intelligence Link files first

      this.state.ack_ids.forEach((e) => {
        id: e;
      });
      const res = await axios.post(POST_ACKNOWLEDGE_EXT_RAC_FILE(userId), {
        ack_ids: this.state.ack_ids,
      });

      // 2️⃣ If response contains date_filter, store it in localStorage
      if (res && res.data && res.data.date_filter) {
        useBoundStore.getState().setNotificationSeenUnseen({
          external_rac_files_unseen: 0,
        });
        const { from, to } = res.data.date_filter;
        const updatedDateObj = {
          start_date: from,
          end_date: to,
          period: "from_to",
        };

        localStorage.setItem(
          "dateObjRecentExtRaC",
          JSON.stringify(updatedDateObj),
        );
      }

      // 3️⃣ Navigate to the new page AFTER storing dateObj
      this.props.history.push({
        pathname: "/newbfiles/externally-completed-bfiles",
        search: `?dates&${new URLSearchParams({
          title: EXTERNAL_RAC_COMPLETED_BY_CLIENT,
          selected_card_type: CARD_HISTORY_TYPE.EXTERNALLY_COMPLETED_BFILE,
        }).toString()}`,
      });
    } catch (err) {
      console.error("Error acknowledging Intelligence Link files:", err);
    }
  };

  componentDidUpdate(prevProps) {
    const searchNotUndefined =
      typeof this.props.match.params.search !== "undefined";
    if (this.props.location !== prevProps.location) {
      if (!searchNotUndefined) {
        this.setState({ search: "" });
      }
      this.loadUser();
      if (
        this.props.auth.user.user_type == EA ||
        this.props.auth.user.user_type == LSP
      ) {
        this.fetchRecentExtRACCount();
      }
      this.onRouteChanged();
    }

    if (
      searchNotUndefined &&
      prevProps.match.params.search != this.props.match.params.search
    ) {
      this.setState({ search: this.props.match.params.search });
    }
    // if
    // if(this.props.match.params.search == "undefined" && searchNotUndefined === false) {

    //   alert(123)
    // 	this.setState({search: "", showSearch: false});

    // }
  }

  onRouteChanged() {
    F.log("ROute path name => ", this.props.location.pathname);

    let prev = this.props.location.pathname.split("/");
    //  F.log("ROute path name prev => ", JSON.stringify(prev)); // ["","wizard","step","2"]
    let current = prev[prev.length - 1];
    if (
      current === "hoopinsure-u" ||
      current === "philosophy" ||
      current === "training"
    ) {
      document.body.classList.add("dropdown_for_hoopin");
      F.log("ROute = > ", current);
    } else {
      F.log("ROute exit = > ", current);
      this.setState({
        selected_key: current,
      });

      document.body.classList.remove("dropdown_for_hoopin");
    }
  }

  componentDidMount() {
    this.isLayoutMounted = true;
    this.unsubscribeNotification = useBoundStore.subscribe((state) => {
      this.setState({
        unseen_notifications: state.notificationUI.unseen_notifications,
        external_rac_files_unseen: state.notificationUI.external_rac_files_unseen,
        is_notification_cross_icon_clicked: state.notificationUI.is_notification_cross_icon_clicked
      });
    }
    );



    let prev = this.props.location.pathname.split("/");
    let current = prev[prev.length - 1];

    this.loadUser();
    if (
      this.props.auth.user.user_type == EA ||
      this.props.auth.user.user_type == LSP
    ) {
      this.fetchRecentExtRACCount();
    }

    if (
      current === "hoopinsure-u" ||
      current === "philosophy" ||
      current === "training"
    ) {
      F.log("ROute = > ", current);
      document.body.classList.add("dropdown_for_hoopin");
    } else {
      F.log("ROute exit = > ", current);

      document.body.classList.remove("dropdown_for_hoopin");
    }

    if (
      this.props.auth.user.user_type === "EA" &&
      this.props.auth.user.id === 2
    ) {
      // this.setState({ selected_key: ['all-bfiles', 'bfiles'] })
      this.setState({ selected_key: ["dashboard"] });
    }
  }




  componentWillUnmount() {
    this.isLayoutMounted = false;
    this.unsubscribeNotification && this.unsubscribeNotification();
  }



  resetUseBoundStorage = () => {
    useBoundStore.getState().resetRSFSCardFilters();
    useBoundStore.getState().resetFsFilters();
    useBoundStore.getState().resetAMDashboardFilter();
    useBoundStore.getState().resetGlobalDashboardFilter();
    useBoundStore.getState().resetUserById();
    useBoundStore.getState().resetUserInfo();
  };

  logout = () => {
    const { socket, clearSocket } = useSocketStore.getState();
    this.props.logout((result) => {
      if (result.success) {
        if (socket) {
          socket.disconnect();
          console.log("Socket disconnected on logout");
          clearSocket();
        }
        localStorage.clear();
        sessionStorage.clear();
        this.resetUseBoundStorage();
        this.setState({
          logout: true,
        });
      }
    });
    localStorage.removeItem("zustand-storage");
  };

  onCollapse = (collapsed) => {
    useBoundStore.getState().setNotificationSeenUnseen({
      side_bar_collapsed: collapsed,
    });
    this.setState({ collapsed });
  };

  handleClick = (e) => {
    // localStorage.removeItem("agGridColumnState");
    this.setState(
      {
        selected_key: null,
      },
      () => {
        if (e.keyPath.includes("help")) {
          this.setState({
            liveSupportSelected: true,
            selected_key: e.keyPath,
          });
        } else {
          this.setState({
            selected_key: e.keyPath,
          });
        }
        if (
          !window.location.hash.includes("/super-admin/active-agencies") &&
          !window.location.hash.includes("/super-admin/inactive-agencies")
        ) {
          this.setState({
            total_agencies: null,
          });
        }
      },
    );
  };
  goTo = (path) => {
    F.log("Path = > ", path);
    this.props.history.push(path);
  };
  updateLang = (lang) => {
    this.setState({ lang });
  };
  search = () => {
    const { search } = this.state;

    const searchPurify = F.removeSpecialCharactersFromString(search);

    if (searchPurify.trim().length > 0) {
      this.props.history.push("/search/" + searchPurify);
    }
  };

  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.search.bind(this));
    });
  };

  setWizardValue = (value) => {
    this.setState(value);
  };

  checkMenuTitle = () => {
    const menuTitle = localStorage.getItem("menuTitle");
    return menuTitle !== null && menuTitle !== undefined && menuTitle !== ""
      ? menuTitle
      : "";
  };



  isDisabled = () => {
    const isBtnDisabled = (this.state.isRequestButtonDisable.review == 0 &&
      this.state.isRequestButtonDisable.vonboard == 0);
    return isBtnDisabled;
  };


  switchUser = (userId) => {
    this.setState({ loading: true });

    axios
      .post(`/api/switchuser/${userId}`)
      .then((res) => {
        this.setState({ loading: false });

        if (!res.data.success) {
          return message.error(F.translate(`Can't switch to the user.`));
        }

        const user = res.data.user;

        useBoundStore.getState().resetUserInfo();
        useBoundStore.getState().resetUserById();

        Cookies.set(
          "user_info",
          JSON.stringify(user),
          {
            secure: true,
            sameSite: 'Lax',
            path: '/',
          }
        );
        localStorage.setItem("roles", JSON.stringify([]));
        useBoundStore.getState().resetAgencyInfo();
        clearSharedDashboardDateState();
        localStorage.setItem('user_t', "");
        const saUserRoute = this.state.sa_user_route;
        this.props.history.push(saUserRoute);
        window.location.reload();
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Can't switch to the user.`));
      });
  };

  switchBackToAdmin = () => {
    this.switchUser(1);
  }



  copyToClipboard = () => {
    let user = useBoundStore.getState().userInfo;
    let link = "";
    if (user.user_agency_assoc && user.user_agency_assoc.length > 0) {
      const agencyIdEncrypted = F.encrypt(user.user_agency_assoc[0].agency_id);
      const userIdEncrypted = F.encrypt(user.id);

      link = `${window.location.origin}/app/create-bfile/${agencyIdEncrypted}/${userIdEncrypted}`;

      navigator.clipboard.writeText(link)
        .then(() => {
          console.log("Copied link:", link);
          message.success("Intelligence Link copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy", err);
        });
    }
  };



  render() {
    const { logout, lang, isRequestButtonDisable, dp_url,
      unseen_notifications, external_rac_files_unseen, is_notification_cross_icon_clicked
    } = this.state;
    const showHeaderShift = !is_notification_cross_icon_clicked && unseen_notifications > 0 && external_rac_files_unseen > 0;
    const {
      ea,
      lsp,
      efs,
      vonboarder,
      vonboardadmin,
      reviewscheduler,
      reviewadmin,
      superadmin,
      mortgage_broker,
      rso,
      agency_manager,
      RSFS_Admin,
      VONSCHEDULER,
    } = this.state.menus;

    let user = this.props.auth.user;



    // const pathData = window.location.hash.split("/"); // ["#","wizard","step","2"]
    // const isRouteWizard = pathData.includes("wizard") || pathData.includes("wizard?new");

    if (logout) {
      return <Redirect to={"/login"} />;
    }

    // const selected_key = this.props.menu;
    const component = this.props.component;

    if (typeof user.language !== "undefined") {
      if (user.language === null || user.language === "") {
        user.language = "en";
      }
    } else {
      user.language = "en";
    }

    window.translate_lang = user.language;

    const pathData = this.props.location.pathname.split("/"); // // ["","wizard","step","2"]
    const isRouteWizard = pathData.includes("wizard");
    const isSearchPage = pathData.includes("search");
    const isOnViewProfilePage = pathData.some(
      (e) => e.indexOf("/customer/") > -1,
    );

    F.log("pathData==>>" + JSON.stringify(pathData));
    // F.log("selected_key==>>" + this.state.selected_key);
    // F.log("pathData==>> isRouteWizard", isRouteWizard);
    // if(this.state.selected_key){
    //   console.log(F.getObjMenufromKey(this.state.selected_key[0]),isOnViewProfilePage,isRequestButtonDisable)
    // }

    let currentmenu =
      (this.state.selected_key && this.state.selected_key[0]) ||
      this.props.menu[0];

    const selectedRoleFilter = useBoundStore.getState().RSFSCardFilters
      .selectedToggle;
    // console.log("roles ----", selectedRoleFilter);

    let menu = [];
    switch (user.user_type) {
      case "REVIEWSCHEDULER":
        menu = reviewscheduler;
        break;
      case "RSO":
        menu = rso;
        break;
      case "REVIEWADMIN":
        menu = reviewadmin;
        break;
      case "SUPER_ADMIN":
        menu = superadmin;
        break;
      case "MORTGAGE_BROKER":
        menu = mortgage_broker;
        break;
      case "AGENCY_MANAGER":
        menu = agency_manager;
        break;
      case "LSP":
        menu = lsp;
        break;
      case "EFS":
        menu = efs;
        break;
      case "VONBOARDER":
        menu = vonboarder;
        break;
      case "EA":
        if (user.id === 2) menu = vonboardadmin;
        else menu = ea;
        break;
      case "BOBREVIEWADMIN":
        menu = RSFS_Admin;
        break;
      case "VONSCHEDULER":
        menu = VONSCHEDULER;
        if (selectedRoleFilter === REVIEWSCHEDULER) {
          menu = menu.filter((item) => item.key !== "claimed-bfiles");
        }
        break;
      default:
        break;
    }

    return (
      <Provider language={user.language} translation={translation}>
        <Layout style={{ height: "100%", width: "100%", position: "fixed" }}>
          <Sider
            className="menu"
            breakpoint="lg"
            collapsible
            collapsedWidth={100}
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
            width={220}
            style={{ height: "100%", overflow: "auto", overflowX: "hidden" }}
            trigger={
              <img
                style={{
                  transform: `rotate(${this.state.collapsed ? 0 : 180}deg)`,
                }}
                src={require("./assets/icons/menu/rightarrow.png")}
                width={20}
              />
            }
          >
            <div className="logo" />
            <DashMenu
              handleClick={this.handleClick}
              selected_key={
                this.state.selected_key
                  ? this.state.selected_key
                  : this.props.menu
              }
              menu={menu}
              selected_menu={(selected_menu) =>
                this.setState({ selected_menu })
              }
              collapsed={this.state.collapsed}
              goTo={this.goTo}
              user={user}
              history={this.props.history}
              isWizardValueUpdated={this.state.isWizardValueUpdated}
              setWizardValue={this.setWizardValue}
            />



            {/* Sticky Button */}
            {
              // !isRouteWizard &&
              //   !isSearchPage &&
              ((user.user_type === "EA" && user.id !== 2) ||
                user.user_type === "LSP") && (
                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    padding: "12px",
                    textAlign: "center"
                  }}
                >
                  {this.state.collapsed ? (
                    // <Tooltip title="Copy Intelligence Link"
                    // placement="right">
                    <Popover
                      content={`${COPY_RAC_POP_OVER}`}
                      overlayClassName="copy-popover"
                      placement="top"
                      trigger="hover"
                    >
                      <Button
                        shape="circle"
                        icon="copy"
                        onClick={this.copyToClipboard}
                        style={{
                          background: "#fff",
                          border: "none",
                          color: "#164897"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#E6F0FF";
                          e.currentTarget.style.transform = "scale(1.05)";
                          e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#fff";
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      />
                    </Popover>
                    // </Tooltip>
                  ) : (
                    <Popover
                      content={`${COPY_RAC_POP_OVER}`}
                      placement="top"
                      trigger="hover"
                    >
                      <Button
                        type="primary"
                        icon="copy"
                        block
                        onClick={this.copyToClipboard}
                        style={{
                          background: "#fff",
                          borderRadius: 50,
                          border: "none",
                          color: "#164897",
                          fontSize: 14,
                          overflow: "hidden",
                          padding: "0 0px",
                          textOverflow: "clip",
                          whiteSpace: "nowrap"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#E6F0FF";
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#fff";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        Copy Intelligence Link
                      </Button>
                    </Popover>
                  )}
                </div>
              )}

          </Sider>

          <Layout
            style={{
              height: `${this.state.liveSupportSelected && isRouteWizard ? "95%" : "100%"
                }`,
              width: "100%",
            }}
          >
            {/* <Header style={{ background: "#fff", padding: 0 }}> */}
            {true && (
              <div className="header-layout">
                <div className="layoutsearchbar">
                  <Button
                    id="mobile-menu-icon"
                    onClick={() =>
                      this.setState((prevState) => ({
                        collapsed: !prevState.collapsed,
                      }))
                    }
                  >
                    <Icon type="menu-unfold" />
                  </Button>

                  {!this.state.showSearch && (
                    <Button
                      id="search-icon"
                      onClick={() => this.setState({ showSearch: true })}
                    >
                      <Icon type="search" />
                    </Button>
                  )}
                  <div
                    className={
                      this.state.showSearch ? "searchForm show" : "searchForm"
                    }
                  >
                    <Button
                      onClick={() => this.setState({ showSearch: false })}
                    >
                      <Icon type="close" />
                    </Button>
                    <Translator>
                      {({ translate }) => (
                        <Input
                          className="layoutsearch input-ellipse"
                          prefix={
                            <Icon type="search" style={{ color: "gray" }} />
                          }
                          value={this.state.search}
                          placeholder={translate({
                            text: `Search All B Files`,
                          })}
                          style={{ width: "100%" }}
                          onChange={(e) => this.searchUser(e)}
                          onPressEnter={this.search.bind(this)}
                        />
                      )}
                    </Translator>
                  </div>
                </div>

                {(user.user_type === EA || user.user_type == LSP) &&
                  this.state.new_external_rac_count > 0 && (
                    <div
                      style={{
                        backgroundColor: "#E6F0FF", // light blue banner
                        padding: "12px 20px",
                        borderRadius: "8px",
                        // marginTop: "10px",
                        display: "inline-block",
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        cursor: "pointer",
                      }}
                      onClick={this.handleClickAcknowledgeRACFiles}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.02)";
                        e.currentTarget.style.boxShadow =
                          "0px 4px 12px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0px 2px 6px rgba(0,0,0,0.1)";
                      }}
                    >
                      <p
                        style={{ margin: 0, color: "#164897", fontWeight: 500 }}
                      >
                        <span
                          style={{
                            backgroundColor: "#164897",
                            color: "#fff",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            marginRight: "8px",
                            fontWeight: "bold",
                          }}
                        >
                          {this.state.new_external_rac_count}
                        </span>
                        New External Intelligence Link Completed by Client
                      </p>
                    </div>
                  )}

                <div className="layout-profile">
                  <span
                    className="username"
                    style={{
                      color: "black",
                      padding: "0px 14px",
                      wordWrap: "inherit",
                    }}
                  >
                    {/* <Avatar style={{ marginRight: 10 }} size={26} src={dp_url || "https://api.dicebear.com/7.x/miniavs/svg?seed=1"} /> */}
                    {dp_url && dp_url !== null ? (
                      <Avatar
                        style={{ marginRight: 10, color: "red" }}
                        size={26}
                        src={dp_url}
                      />
                    ) : (
                      <span
                        style={{
                          marginRight: 10,
                          color: "rgb(22, 72, 151)",
                          background: "#F0F2F5",
                          borderRadius: "50%",
                          padding: "5px",
                          fontWeight: "600",
                          fontFamily: "Poppins",
                        }}
                      >
                        {getNameInitials(
                          `${user.first_name} ${user.last_name}`,
                        )}
                      </span>
                    )}
                    <Translate text={`Welcome`} /> {user.first_name}
                  </span>
                  <Notificationbell history={this.props.history} />

                  <Divider
                    type="vertical"
                    style={{
                      margin: 10,
                      height: 21,
                      display: isOnViewProfilePage && "none",
                    }}
                  />
                  <Tooltip
                    placement="bottom"
                    title={<Translate text={`Logout`} />}
                  >
                    <a
                      className="i logout"
                      onClick={this.logout}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.logout();
                        }
                      }}
                      tabIndex="0" // Ensures the element is focusable
                    >
                      <Icon type="logout" />
                    </a>
                  </Tooltip>
                </div>
              </div>
            )}
            <Row className={`pageheader ${showHeaderShift ? "hasNotifications" : ""}`}>
              {/* <Row className={`pageheader 
              ${(unseen_notifications > 0 && external_rac_files_unseen > 0) ? 'hasNotifications' : ''}`}> */}
              {!isSearchPage ? (
                <Col className="pagename" md={15} span={24}>
                  <Translate
                    text={
                      (F.getObjMenufromKey(menu, currentmenu) &&
                        F.getObjMenufromKey(menu, currentmenu).title) ||
                      this.props.title ||
                      this.checkMenuTitle()
                    }
                  />
                </Col>
              ) : null}
              <Col xs={24} md={9} span={24}>
                <div className="right">
                  {(this.state.sa_user_route && (user.user_type == EA || user.user_type == LSP ||
                    user.user_type == AGENCY_MANAGER || user.user_type == REVIEWSCHEDULER
                    || user.user_type == "VONSCHEDULER" || user.user_type == VONBOARDER)) ? (
                    <Fragment>
                      <Popover
                        content={`${SWITCH_BACK_TO_ADMIN_POP_OVER}`}
                        placement="bottom"
                        trigger="hover"
                      >
                        <Button
                          type="primary"
                          style={{
                            marginRight: isOnViewProfilePage && "15px",
                            background: "#164897",
                            borderRadius: 50,
                            fontSize: 12,
                            boxShadow: "none",
                            border: "none",
                          }}
                          icon="arrow-left"
                          onClick={() => {
                            this.switchBackToAdmin();
                          }}
                        >
                          <Divider type="vertical" />
                          {SWITCH_BACK_TO_ADMIN}
                        </Button>
                      </Popover>
                      <Divider
                        type="vertical"
                        style={{
                          marginLeft: 5,
                          marginRight: 5,
                          display: isOnViewProfilePage && "none",
                        }}
                      />
                    </Fragment>

                  ) : null}
                  {!isRouteWizard &&
                    !isSearchPage &&
                    //
                    ((user.user_type === "EA" && user.id !== 2) ||
                      user.user_type === "LSP") ? (
                    <span className="create_bfile_btn">
                      {
                        // <Fragment>
                        //   {" "}
                        //   <Button
                        //     type="primary"
                        //     icon="copy"
                        //     onClick={() => this.copyToClipboard()}
                        //     style={{
                        //       background: "#164897",
                        //       borderRadius: 50,
                        //       fontSize: 12,
                        //       border: "none",
                        //       boxShadow: "none",
                        //       display: isOnViewProfilePage && "none",
                        //     }}
                        //   >
                        //     <Divider type="vertical" />
                        //     Copy Intelligence Link
                        //   </Button>{" "}
                        //   <Divider
                        //     type="vertical"
                        //     style={{
                        //       marginLeft: 5,
                        //       marginRight: 5,
                        //       display: isOnViewProfilePage && "none",
                        //     }}
                        //   />{" "}
                        // </Fragment>
                      }

                      {this.state.isRequestButtonDisable &&
                        this.state.isRequestButtonDisable.customerPath == 1 && (
                          <Fragment>
                            <Popover
                              content={REQUEST_CALL_POP_OVER}
                              placement="top"
                              trigger={this.isDisabled() ? [] : "hover"}
                            >
                              <Button
                                type="primary"
                                icon="plus"
                                onClick={() => {
                                  window.localStorage.bfileType = "quick";
                                  window.localStorage.removeItem("wizard");
                                  setTimeout(() => {
                                    this.setState({ send_followup_modal: true });
                                  }, 100);
                                }}
                                disabled={this.isDisabled()}
                                style={{
                                  background: "#FF7152",
                                  borderRadius: 50,
                                  fontSize: 12,
                                  border: "none",
                                  boxShadow: "none",
                                  display: isOnViewProfilePage && "none",
                                }}
                              >
                                <Divider type="vertical" />
                                Request Call
                              </Button>
                            </Popover>
                            <Divider
                              type="vertical"
                              style={{
                                marginLeft: 5,
                                marginRight: 5,
                                display: isOnViewProfilePage && "none",
                              }}
                            />
                          </Fragment>
                        )}
                      {this.state.isRequestButtonDisable.customerPath == 1 ? (
                        <Popover
                          content={`${LAUNCH_CALCULATOR_POP_OVER}`}
                          placement="top"
                          trigger="hover"
                        >
                          <Button
                            type="primary"
                            style={{
                              marginRight: isOnViewProfilePage && "15px",
                              background: "#164897",
                              borderRadius: 50,
                              fontSize: 12,
                              boxShadow: "none",
                              border: "none",
                            }}
                            icon="calculator"
                            onClick={() => {
                              window.localStorage.bfileType = "new";
                              window.localStorage.removeItem("wizard");
                              setTimeout(() => {
                                this.props.history.push("/wizard?new", {
                                  ...this.props.history.location.state,
                                });
                              }, 100);
                            }}
                          >
                            <Divider type="vertical" />
                            Launch Calculator
                          </Button>
                        </Popover>
                      ) : null}
                      <SentFollowupModal
                        history={this.props.history}
                        user={{ ...this.props.auth.user }}
                        requestButtonVisible={this.state.isRequestButtonDisable}
                        bfile={{ agency: { agency_id: user.agency_id }, user }}
                        showModal={this.state.send_followup_modal}
                        hideModal={() =>
                          this.setState({ send_followup_modal: false })
                        }
                      />
                    </span>
                  ) : null}
                  {user.user_type === SUPER_ADMIN &&
                    !isSearchPage &&
                    this.state.total_agencies ? (
                    <div style={{ color: "#000", fontWeight: "600" }}>
                      Total Count : {this.state.total_agencies}
                    </div>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Content
              className={
                isRouteWizard ? "wizardcomponentcontent" : "componentcontent"
              }
            >
              {React.cloneElement(component, {
                collapsed: this.state.collapsed,
                isWizardValueUpdated: this.state.isWizardValueUpdated,
                setWizardValue: this.setWizardValue,
                setState: (value) => this.setState(value),
              })}
            </Content>
            {/* {isRouteWizard && <Content
              style={{
                margin: "10px 16px",
              }}
            >
              {component}
            </Content>
            {!isRouteWizard && <Footer style={{ textAlign: "center" }}>
              © 2024 PersistEplan Software, LLC - B File is a registered trade
              mark of PersistEplan Software, LLC (patent pending)
            </Footer> */}
          </Layout>
        </Layout>
      </Provider>
    );
  }
}

export default DashLayout;



// WEBPACK FOOTER //
// ./src/Layout.js